import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Avatar, Box, Button, Divider, Fab, Paper, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import { DeletedMatGroup, uploadMaterialGroup } from '../../services/material-services';
import { CssTextField } from '../layout/elements';
import { NotificationManager } from 'react-notifications';
import DeleteIcon from '@mui/icons-material/Delete';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import WbIridescentIcon from '@mui/icons-material/WbIridescent';
import AttributionIcon from '@mui/icons-material/Attribution';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import ProgressWait from '../layout/progress';
import SelectLang from './mat_lang-select';



const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}));


function MaterialGroup() {
    
    const { authData } = useAuth();
    const [isAdmin, setIsAdmin] = useState(false);


    const location = useLocation();
    const { state } = location;

    const [ image, setImage ] = useState(null);
    const [ imageSelect, setImageSelect ] = useState(null);
    const [altImage, setAltImage ] = useState('');
    
    const [ imageLogo, setImageLogo ] = useState(null);
    const [ imageLogoSelect, setImageLogoSelect ] = useState(null);
    const [altImageLogo, setAltImageLogo ] = useState('');

    const [matName, setMatName ] = useState('');
    const [matBio, setMatBio ] = useState('');
    const [matID, setMatID ] = useState(0);
    const [statusReq, setStatusReq ] = useState(false);
    
    const [matLang, setMatLang ] = useState('');

    const [metaDisc, setMetaDisc ] = useState('');
    const [metaTitle, setMetaTitle ] = useState('');
    const [metaKeywords, setMetaKeywords ] = useState('');
    const [metaAuthor, setMetaAuthor ] = useState('');
    const [loading, setLoading ] = useState(false);

    const cssClass = useStyles();
    // const navigate = useNavigate();
    

    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            setImageSelect(undefined)
            return
        }

        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageSelect(e.target.files[0]);
        // console.log(e.target.files[0]);
        setImage(URL.createObjectURL(e.target.files[0]));
    }

    const onSelectLogoFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            setImageLogoSelect(undefined)
            return
        }

        // setImage(e.target.files[0])
        // I've kept this example simple by using the first image instead of multiple
        setImageLogoSelect(e.target.files[0]);
        // console.log(e.target.files[0]);
        setImageLogo(URL.createObjectURL(e.target.files[0]));
    }

    useEffect(() => {
        // window.scrollTo(0, 0);
        // console.log(location);
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium);
        }
        setStatusReq(false);
        setMatID(0);
        setMatName('');
        setMatBio('');
        setImage(null);
        setImageLogo(null);
        setAltImage('');
        setAltImageLogo('');
        setMetaDisc('');
        setMetaTitle('');
        setMetaKeywords('');
        setMetaAuthor('');
        setMatLang('');
        
        if (state != null){
            setStatusReq(true);
            if (state.id){
                setMatID(state.id);
            }
            if (state.name){
                setMatName(state.name);
            }
            if (state?.lang){
                setMatLang(state.lang);
            }
            
            if (state.image){
                setImage(state.image);
            }
            if (state.image_logo){
                setImageLogo(state.image_logo);
            }

            if (state.bio){
                setMatBio(state.bio);
            }
            if (state.alt_image){
                setAltImage(state.alt_image);
            }
            if (state.alt_image_logo){
                setAltImageLogo(state.alt_image_logo);
            }

            if (state.meta_description){
                setMetaDisc(state.meta_description);
            }
            if (state.meta_og_title){
                setMetaTitle(state.meta_og_title);
            }
            if (state.meta_keywords){
                setMetaKeywords(state.meta_keywords);
            }
            if (state.meta_author){
                setMetaAuthor(state.meta_author);
            }
        }
        // if(imageSelect){
        //     // setImage(imageSelect);
        //     console.log(image);
        //     setImage(URL.createObjectURL(imageSelect));
        // }
    }, [state]);

    const submitDelete = async e =>{
        setLoading(true);
        const delMaterial = await DeletedMatGroup(authData?.token, {'mat_id' : matID});
        if (delMaterial){
            NotificationManager.success('گروه با موفقیت حذف شد');
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان حذف گروه وجود دارد');
        }
        setLoading(false);
    }


    const handelSubmitImage = async e => {
        e.preventDefault();
        setLoading(true);
        const uploaddata = new FormData();
        if(imageSelect){
            uploaddata.append('image', imageSelect, imageSelect.name);
        }
        if(imageLogoSelect){
            uploaddata.append('image_logo', imageLogoSelect, imageLogoSelect.name);
        }
        if(matID){
            uploaddata.append('id', matID);
        }
        if(matName){
            uploaddata.append('name', matName);
        }
        if(matBio){
            uploaddata.append('bio', matBio);
        }
        if(altImage){
            uploaddata.append('alt_image', altImage);
        }
        if(altImageLogo){
            uploaddata.append('alt_image_logo', altImageLogo);
        }
        if(metaDisc){
            uploaddata.append('meta_description', metaDisc);
        }
        if(metaKeywords){
            uploaddata.append('meta_keywords', metaKeywords);
        }
        if(metaAuthor){
            uploaddata.append('meta_author', metaAuthor);
        }
        if(metaTitle){
            uploaddata.append('meta_og_title', metaTitle);
        }
        if(matLang){
            uploaddata.append('lang_id', matLang);
        }

        
        const addNewMaterial = await uploadMaterialGroup(authData?.token, uploaddata);
        // console.log("addNewMaterial", addNewMaterial);
        if (addNewMaterial){
            NotificationManager.success('گروه جدید به برنامه اضافه شد');
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ثبت گروه وجود دارد');
        }
        setLoading(false);
    }
    
    const handleSelectLang = (value) => {
        // console.log(value);
        setMatLang(value?.id);
    };

    if (loading) return <ProgressWait statusWait={true}/> 

  return (
    <React.Fragment>
    <div style={{minHeight: 1000}}>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
            <Typography
                fontFamily='b_mitra' 
                component="div"
                variant="h2"
                >
                کنترل گروه
            </Typography>
            {isAdmin && statusReq &&
                <Fab variant="extended" 
                    size="small" color="secondary" 
                    aria-label="add" 
                    sx={{
                        textAlign: 'right'
                    }}
                    onClick={submitDelete}
                    >
                    <DeleteIcon sx={{ mr: 1 }} />
                    
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h5"
                        >
                        حذف
                    </Typography>
                </Fab>
            }
        </div>

        <hr/>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'left',
              }}
            >
            <Paper elevation={3} sx={{
                display: 'block',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right',
                }} >

                <form onSubmit={handelSubmitImage}>
                    <div style={{textAlign: 'right', marginRight: 20}}>
                        <Box sx={{  display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                            <div>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none', width: '100%', height: '100%' }}
                                            id="raised-button-file"
                                            multiple
                                            type="file"
                                            onChange={onSelectFile}
                                        />
                                        <label htmlFor="raised-button-file">
                                            <Button variant="raised" component="span" >
                                                <Avatar sx={{width: '200px', height: '100px'}}
                                                    src={image} />
                                            </Button>
                                        </label>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <AttributionIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CssTextField id="input-image-alt" 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    >
                                                    نام عکس (Image Alt)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard" value={altImage}
                                            onChange={ e => setAltImage( e.target.value )} />
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none', width: '100%', height: '100%' }}
                                            id="raised-button-logo-file"
                                            multiple
                                            type="file"
                                            onChange={onSelectLogoFile}
                                        />
                                        <label htmlFor="raised-button-logo-file">
                                            <Button variant="raised" component="span" >
                                                <Avatar sx={{width: '200px', height: '100px'}}
                                                    src={imageLogo} />
                                            </Button>
                                        </label>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <AttributionIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CssTextField id="input-logo-name" 
                                            label={(
                                                <Typography
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    >
                                                    نام لوگو عکس (Logo Alt)
                                                </Typography>
                                            )}
                                            fullWidth
                                            variant="standard" value={altImageLogo}
                                            onChange={ e => setAltImageLogo( e.target.value )} />
                                    </Grid>
                                </Grid>
                            </div>
                        </Box>
                        <br/>
                        <Divider />
                        <br/>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <AlignHorizontalRightIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item >
                                <SelectLang
                                    onChange={handleSelectLang} 
                                    selectedValue={matLang} />
                            </Grid>
                            <Grid item>
                                *
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <AlignHorizontalRightIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item>
                                <CssTextField id="input-with-sx02" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            نام گروه*
                                        </Typography>
                                    )}
                                    variant="standard" value={matName}
                                    onChange={ e => setMatName( e.target.value )} />
                            </Grid>
                            <Grid item>
                                *
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <WbIridescentIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item>
                                <CssTextField id="input-with-sx03" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            مشخصات
                                        </Typography>
                                    )}
                                    variant="standard" value={matBio}
                                    fullWidth
                                    onChange={ e => setMatBio( e.target.value )} />
                            </Grid>
                        </Grid>
                        
                    </div>
                    <br />
                    <Divider />
                    
                    <div style={{textAlign: 'right', marginRight: 20}}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h3"
                            >
                            متا تگ ها
                        </Typography>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <LocalOfferIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <CssTextField id="input-meta-header" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            هدر (متاتگ)
                                        </Typography>
                                    )}
                                    variant="standard" value={metaTitle}
                                    onChange={ e => setMetaTitle( e.target.value )} />
                            </Grid>
                        </Grid>
                            
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item sx={{marginTop: '1fr'}}>
                                <LocalOfferIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-meta-remarks" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            توضیحات (متاتگ)
                                        </Typography>
                                    )}
                                    multiline
                                    fullWidth
                                    rows={2} 
                                    className={cssClass.header_dtl}
                                    variant="standard" value={metaDisc}
                                    onChange={ e => setMetaDisc( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <LabelImportantIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-meta-keys" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            واژه کلیدهای اصلی
                                        </Typography>
                                    )}
                                    fullWidth
                                    variant="standard" value={metaKeywords}
                                    onChange={ e => setMetaKeywords( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-meta-autor" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            نویسنده (متاتگ)
                                        </Typography>
                                    )}
                                    variant="standard" value={metaAuthor}
                                    onChange={ e => setMetaAuthor( e.target.value )} />
                            </Grid>
                        </Grid>
                    </div>
                    
                    <Divider />
                    
                    <br/>
                                
                    <Button sx={{fontFamily: 'b_mitra', paddingLeft: 5, paddingRight: 5, margin: 5}} 
                        variant="contained" 
                        color="primary" 
                        type='submit'
                        disabled={!matName }>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h4"
                            >
                            ثبت
                        </Typography>
                        
                    </Button>
                </form>
            </Paper>
        </Box>
    </div>
    </React.Fragment>
  );
}

export default MaterialGroup;
